import React from 'react';
import {Button, Form, Input, message, Row, Select, Table} from "antd";
import Axios from "../../../utils/axios";
import PATH_URL from "../../../utils/url";

let userName = null;

class CompletedOrderDetailed extends React.Component {
    state = {
        loading: true,
        current: 1,
        pageSize: 10,
        total: 0,
        data: null,
        licensePlate: null,
        ownerName: null,
        siteName: null,
        groupName: null,
        remarks: null,
        allGroupUserData: null,
    }

    componentDidMount() {
        userName = JSON.parse(window.sessionStorage.getItem("userName"));
        this.initData();
        this.initGroupUserDate();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }

    inputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        }, () => {
            this.searchOrder();
        });
    }
    /**
     * 初始化订单信息
     */
    initData = () => {
        Axios({
            method: 'get',
            url: PATH_URL.LIST_COMPLETED_ORDER_INFO_URL,
            params: {
                orderBy: userName,
                licensePlate: this.state.licensePlate,
                groupName: this.state.groupName,
                ownerName: this.state.ownerName,
                siteName: this.state.siteName,
                remarks: this.state.remarks,
                pageNum: this.state.current,
                pageSize: this.state.pageSize,
                year: this.props.year,
                month: this.props.month,
                status: 1,
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    this.setState({
                        data: res.data.data.list,
                        loading: false,
                        total: res.data.data.total,
                    });
                } else {
                    this.setState({
                        loading: false,
                    });
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                this.setState({
                    loading: false,
                });
                message.error(res.message);
            }
        }).catch(err => {
            this.setState({
                loading: false,
            });
            console.log(err);
        });
    }
    initGroupUserDate = () => {
        Axios({
            method: 'get',
            url: PATH_URL.LIST_GROUP_USER + "/" + JSON.parse(window.sessionStorage.getItem("userName")),
        }).then(res => {
            if (res.status === 200) {
                if (res.data.code === 200) {
                    let other = {};
                    other.userName = JSON.parse(window.sessionStorage.getItem("userName"));
                    other.groupName = "其他";
                    let data = res.data.data;
                    data.push(other);
                    this.setState({
                        allGroupUserData: data
                    });
                } else {
                    message.error(res.data.message);
                }
            } else if (res.code === 401) {
                message.error(res.message);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    searchOrder = () => {
        this.initData()
    }
    resetSearchOrder = () => {
        this.setState({
            licensePlate: null,
            ownerName: null,
            siteName: null,
            groupName: null,
            remarks: null,
        });
    }
    groupChange = (value, option) => {
        this.setState({
            groupName: value,
        }, () => {
            this.searchOrder();
        })
    }

    render() {
        const columns = [
            {
                title: '车牌',
                dataIndex: 'licensePlate',
                key: 'licensePlate',
                fixed: 'left',
                width: 100,
            },
            {
                title: '车主姓名',
                dataIndex: 'ownerName',
                key: 'ownerName',
                fixed: 'left',
                width: 100,
            },
            {
                title: '车型',
                dataIndex: 'carType',
                key: 'carType',
            },
            {
                title: '车辆类型',
                dataIndex: 'carModel',
                key: 'carModel',
            },
            {
                title: '车辆注册时间',
                dataIndex: 'registrationTime',
                key: 'registrationTime',
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            {
                title: '车主手机号',
                dataIndex: 'ownerTel',
                key: 'ownerTel',
            },
            {
                title: '预约站点',
                dataIndex: 'siteName',
                key: 'siteName',
                ellipsis: true,
            },
            {
                title: '预约时间',
                dataIndex: 'orderTime',
                key: 'orderTime',
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            {
                title: '完成验车时间',
                dataIndex: 'completeTime',
                key: 'completeTime',
                render: (v) => (v ? String(v).substring(0, 10) : '-'),
            },
            {
                title: '所属组员',
                dataIndex: 'groupUser',
                key: 'groupUser',
            },
            {
                title: '备注',
                dataIndex: 'remarks',
                key: 'remarks',
                ellipsis: true,
            }
        ];
        return (
            <div>
                <Form layout='inline'>
                    <Row>
                        <Form.Item
                            label="预约车牌"
                            name="licensePlate"
                            style={{width: 200}}>
                            <Input placeholder="请输入车牌"
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="车主姓名"
                            name="ownerName"
                            style={{width: 200}}>
                            <Input placeholder="请输入姓名"
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="预约站点"
                            name="siteName"
                            style={{width: 200}}>
                            <Input placeholder="请输入站点名称"
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item
                            label="所属组"
                            name="groupUser"
                            style={{width: 150}}>
                            <Select onChange={this.groupChange}
                                    showSearch>
                                {
                                    this.state.allGroupUserData != null ?
                                        this.state.allGroupUserData.map(item => {
                                            return (<Select.Option key={item.userName}
                                                                   value={item.groupName}>{item.groupName}</Select.Option>)
                                        }) : null
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="备注"
                            name="remarks"
                            style={{width: 200}}>
                            <Input placeholder="请输入备注"
                                   onChange={this.inputChange}/>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" onClick={this.searchOrder}>查询</Button>
                            <Button type="primary" htmlType="reset" style={{'marginLeft': '17px'}}
                                    onClick={this.resetSearchOrder}>重置</Button>
                        </Form.Item>
                    </Row>
                </Form>
                <Table columns={columns}
                       size="small"
                       dataSource={this.state.data}
                       rowKey={columns => columns.id}
                       loading={this.state.loading}
                       style={{'marginTop': '20px'}}
                       scroll={{x: 2000}}
                       pagination={{
                           showTotal: () => `共 ${this.state.total} 条`,
                           onShowSizeChange: (current, pageSize) => {
                               this.setState({
                                   current: current,
                                   pageSize: pageSize
                               });
                               setTimeout(() => {
                                   this.initData();
                               }, 100);
                           },
                           total: this.state.total,
                           current: this.state.current,
                           pageSize: this.state.pageSize,
                           onChange: (current, pageSize) => {
                               this.setState({
                                   current: current,
                                   pageSize: pageSize
                               });
                               setTimeout(() => {
                                   this.initData();
                               }, 100);
                           }
                       }}/>
            </div>
        )
    }
}

export default CompletedOrderDetailed;